// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_bx427 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}
.pad_rx9E9 {
  padding: 10px;
}
.header_Ly5Ih {
  padding: 10px 26px 10px 20px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid var(--background);
}
.noItems_M2dMQ {
  text-align: left;
  padding: 20px 20px;
}
.leftIcon_pmc5A {
  font-size: 24px;
  padding: 10px;
  color: #000;
}
@keyframes pulsate_kcEx4 {
  from {
    font-style: 14px;
  }
  to {
    font-size: 18px;
  }
}
.status-started_zaXq9 {
  animation-duration: 0.5s;
  animation-direction: alternate-reverse;
  animation-iteration-count: infinite;
}
.screen_UzUsA .addSystem_KjQpJ {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
.count_yPCcy {
  color: var(--light-grey);
  font-size: 11px;
  padding-left: var(--size-padMedium, 8px);
}
.left_patca {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  min-width: 400px;
}
.left_patca .pagination_PSajD {
  border-top: 1px solid var(--lighter-grey);
  background: white;
  position: absolute;
  bottom: 0;
  margin: 0;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left_patca .pagination_PSajD .innerPagination_QeNy4 {
  margin: 0;
}
.left_patca .list_oUGoq {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 40px;
}
.right_X2CYv {
  position: relative;
  height: 100%;
  overflow-y: auto;
  background: white;
}
.contactHeader_loclR {
  padding: 10px;
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: flex-start;
}
.contactEntry_qFzUe {
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.loading_NI6oS {
  color: var(--pink);
  font-size: var(--font-size-large);
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
}
.loading_NI6oS div {
  margin: 10px;
}
.screen_UzUsA .table_vFOGj {
  position: absolute;
  top: 0;
  max-height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  /* need this for safari!! 8( */
}
.screen_UzUsA .table_vFOGj.empty_l9pyQ {
  bottom: 0;
}
.screen_UzUsA .table_vFOGj .rt-tr-group {
  max-height: 50px;
  font-size: 12px;
  text-align: center;
}
.screen_UzUsA .table_vFOGj .rt-tr-group .rt-tr {
  align-items: center;
}
.screen_UzUsA .table_vFOGj .rt-tr-group .rt-td {
  overflow: visible;
}
.cellDropdown_pC4sv .span_kX2f2 {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/screens/messageRoute/style.css"],"names":[],"mappings":"AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,aAAa;EACb,WAAW;AACb;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf","sourcesContent":["@import \"../../style/theme.css\";\n.content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n}\n.pad {\n  padding: 10px;\n}\n.header {\n  padding: 10px 26px 10px 20px;\n  text-align: right;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 5px solid var(--background);\n}\n.noItems {\n  text-align: left;\n  padding: 20px 20px;\n}\n.leftIcon {\n  font-size: 24px;\n  padding: 10px;\n  color: #000;\n}\n@keyframes pulsate {\n  from {\n    font-style: 14px;\n  }\n  to {\n    font-size: 18px;\n  }\n}\n.status-started {\n  animation-duration: 0.5s;\n  animation-direction: alternate-reverse;\n  animation-iteration-count: infinite;\n}\n.screen .addSystem {\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n}\n.count {\n  color: var(--light-grey);\n  font-size: 11px;\n  padding-left: var(--size-padMedium, 8px);\n}\n.left {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  min-width: 400px;\n}\n.left .pagination {\n  border-top: 1px solid var(--lighter-grey);\n  background: white;\n  position: absolute;\n  bottom: 0;\n  margin: 0;\n  height: 40px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.left .pagination .innerPagination {\n  margin: 0;\n}\n.left .list {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  bottom: 40px;\n}\n.right {\n  position: relative;\n  height: 100%;\n  overflow-y: auto;\n  background: white;\n}\n.contactHeader {\n  padding: 10px;\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  align-items: flex-start;\n}\n.contactEntry {\n  width: 100%;\n  padding: 10px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.loading {\n  color: var(--pink);\n  font-size: var(--font-size-large);\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.6);\n}\n.loading div {\n  margin: 10px;\n}\n.screen .table {\n  position: absolute;\n  top: 0;\n  max-height: 100%;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* need this for safari!! 8( */\n}\n.screen .table.empty {\n  bottom: 0;\n}\n.screen .table :global(.rt-tr-group) {\n  max-height: 50px;\n  font-size: 12px;\n  text-align: center;\n}\n.screen .table :global(.rt-tr-group) :global(.rt-tr) {\n  align-items: center;\n}\n.screen .table :global(.rt-tr-group) :global(.rt-td) {\n  overflow: visible;\n}\n.cellDropdown .span {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_bx427`,
	"pad": `pad_rx9E9`,
	"header": `header_Ly5Ih`,
	"noItems": `noItems_M2dMQ`,
	"leftIcon": `leftIcon_pmc5A`,
	"status-started": `status-started_zaXq9`,
	"screen": `screen_UzUsA`,
	"addSystem": `addSystem_KjQpJ`,
	"count": `count_yPCcy`,
	"left": `left_patca`,
	"pagination": `pagination_PSajD`,
	"innerPagination": `innerPagination_QeNy4`,
	"list": `list_oUGoq`,
	"right": `right_X2CYv`,
	"contactHeader": `contactHeader_loclR`,
	"contactEntry": `contactEntry_qFzUe`,
	"loading": `loading_NI6oS`,
	"table": `table_vFOGj`,
	"empty": `empty_l9pyQ`,
	"cellDropdown": `cellDropdown_pC4sv`,
	"span": `span_kX2f2`,
	"pulsate": `pulsate_kcEx4`
};
export default ___CSS_LOADER_EXPORT___;
